import { render, staticRenderFns } from "./AdminProducers.vue?vue&type=template&id=a7b8c78a&scoped=true&"
import script from "./AdminProducers.vue?vue&type=script&lang=js&"
export * from "./AdminProducers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b8c78a",
  null
  
)

export default component.exports